import { pOturumAc, rKullanici, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import pOtpAl from '../../../../api/models/pOtpAl';
import rOtp from '../../../../api/models/rOtp';

export const action_api_set_input = (body: pOtpAl | null | undefined): IInputAction<pOtpAl> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_OTPAL, true, body);

export const action_async_start = (body: pOtpAl): IPromiseAction<pOtpAl> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OTPAL,
    new Api.User.OtpAl().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rOtp> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOtp> =>
  ActionFunctions.action_async_complete_api<rOtp>(ActionSubTypes.API_OTPAL, data?.Value, error);
